import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useVeltClient } from '@veltdev/react';
import { generateUserData } from './util/user';
import CursorPage from "./pages/CursorsPage/CursorPage";
import FlockPage from "./pages/FlockPage/FlockPage";
import styles from './App.module.css';
import CommentPage from "./pages/CommentsPage/CommentPage";
import CommentsInbox from "./pages/CommentsInbox/CommentsInbox";
import CommentsSidebar from './pages/CommentsSidebar/CommentsSidebar';
import CommentsPopoverPage from "./pages/CommentsPopoverPage/CommentsPopoverPage";
import CommentsStreamPage from "./pages/CommentsStreamPage/CommentsStreamPage";
import CommentsTextPage from "./pages/CommentsTextPage/CommentsTextPage";
import HuddlePage from "./pages/HuddlePage/HuddlePage";
import ArrowPage from "./pages/ArrowPage/ArrowPage";
import RecorderPage from "./pages/RecorderPage/RecorderPage";
import PresencePage from "./pages/PresencePage/PresencePage";
import LiveSelectionPage from "./pages/LiveSelectionPage/LiveSelectionPage";
import UserRequestToolPage from "./pages/UserRequestToolPage/UserRequestToolPage";
import UserInviteToolPage from "./pages/UserInviteToolPage/UserInviteToolPage";
import RewriterPage from "./pages/RewriterPage/RewriterPage";
import CommentsAreaPage from "./pages/CommentsAreaPage/CommentsAreaPage";
import FeedbackPage from "./pages/FeedbackPage/FeedbackPage";
import ReportBugPage from "./pages/ReportBugPage/ReportBugPage";
import ContactUsPage from "./pages/ContactUsPage/ContactUsPage";
import AudioRecorderPage from "./pages/AudioRecorderPage/AudioRecorderPage";
import VideoRecorderPage from "./pages/VideoRecorderPage/VideoRecorderPage";
import ScreenRecorderPage from "./pages/ScreenRecorderPage/ScreenRecorderPage";
import CommentsPageModePage from "./pages/CommentsPageModePage/CommentsPageModePage";
import SingleEditorModePage from "./pages/SingleEditorModePage/SingleEditorModePage";
import LiveStateSyncPage from "./pages/LiveStateSyncPage/LiveStateSyncPage";
import VideoPlayerPage from "./pages/VideoPlayerPage/VideoPlayerPage";
import ViewAnalyticsPage from "./pages/ViewAnalyticsPage/ViewAnalyticsPage";
import CommentThreadPage from "./pages/CommentThreadPage/CommentThreadPage";
import CommentThreadPageError from "./pages/CommentThreadPageError/CommentThreadPageError";
import NotificationsPage from "./pages/NotificationsPage/NotificationsPage";
import NivoChartsPage from "./pages/NivoChartsPage/NivoChartsPage";
import CommentsInlinePage from "./pages/CommentsInlinePage/CommentsInlinePage";
import ReactionsInlinePage from "./pages/ReactionsInlinePage/ReactionsInlinePage";

const App = () => {

  /**
   * Velt Code Example
   * Initializes the Velt SDK.
   */
  const { client } = useVeltClient();




  useEffect(() => {

    if (!client) return;
    // if path is not 'nivo-charts' then set dark mode true
    if (window?.location?.pathname !== '/nivo-charts') {
      client.setDarkMode(true)
    }

    onInitClient();

  }, [client]);

  const onInitClient = async () => {
    // get documentId from url params
    const queryParams = new URLSearchParams(window.location.search);
    const documentId = queryParams.get('documentId');
    const userIndex = queryParams.get('userIndex') ? +queryParams.get('userIndex')! : null;
    const mobileMode = queryParams.get('mobileMode') ? queryParams.get('mobileMode') === 'true' : (queryParams.get('mobileMode') === 'false' ? false : null);

    await client.setDocumentId(documentId || 'docs-mini-demo');

    if (mobileMode !== null) {
      if (mobileMode) {
        await client?.getCommentElement().enableMobileMode();
      } else {
        await client?.getCommentElement().disableMobileMode();
      }
    } else {
      await client?.getCommentElement().disableMobileMode();
    }

    // if (client?.getCommentElement().disableScrollToComment) {
    //   client?.getCommentElement().disableScrollToComment();
    // }

    // let user = generateUserData();

    const users = [
      {
        userId: '1',
        name: 'John Smith',
        photoUrl: 'https://i.pravatar.cc/150?u=1.png',
        email: 'john@trysnippyly.com',
        plan: 'free',
        organizationId: 'velt-docs-demo',
      },
      {
        userId: '2',
        name: 'Maria Garcia',
        photoUrl: 'https://i.pravatar.cc/150?u=2.png',
        email: 'maria@trysnippyly.com',
        plan: 'paid',
        organizationId: 'velt-docs-demo',
      }
    ];

    let user = users[0];

    if (userIndex !== null && userIndex >= 0 && userIndex < users.length) {
      user = users[userIndex];
    }
    await client.identify(user);
  }

  return (
    <div className={styles.appContainer}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CursorPage />} />
          <Route path="cursors" element={<CursorPage />} />
          <Route path="comments" element={<CommentPage />} />
          <Route path="comments-inbox" element={<CommentsInbox />} />
          <Route path="comments-sidebar" element={<CommentsSidebar />} />
          <Route path="comments-popover" element={<CommentsPopoverPage />} />
          <Route path="comments-stream" element={<CommentsStreamPage />} />
          <Route path="comments-text" element={<CommentsTextPage />} />
          <Route path="comments-area" element={<CommentsAreaPage />} />
          <Route path="comments-page-mode" element={<CommentsPageModePage />} />
          <Route path="comment-thread" element={<CommentThreadPage />} />
          <Route path="comment-thread-error" element={<CommentThreadPageError />} />
          <Route path="comments-inline" element={<CommentsInlinePage />} />
          <Route path="presence" element={<PresencePage />} />
          <Route path="flock" element={<FlockPage />} />
          <Route path="huddle" element={<HuddlePage />} />
          <Route path="arrows" element={<ArrowPage />} />
          <Route path="recorder" element={<RecorderPage />} />
          <Route path="audio-recorder" element={<AudioRecorderPage />} />
          <Route path="video-recorder" element={<VideoRecorderPage />} />
          <Route path="screen-recorder" element={<ScreenRecorderPage />} />
          <Route path="rewriter" element={<RewriterPage />} />
          <Route path="live-selection" element={<LiveSelectionPage />} />
          <Route path="user-request-tool" element={<UserRequestToolPage />} />
          <Route path="user-invite-tool" element={<UserInviteToolPage />} />
          <Route path="user-feedback" element={<FeedbackPage />} />
          <Route path="report-bug" element={<ReportBugPage />} />
          <Route path="contact-us" element={<ContactUsPage />} />
          <Route path="single-editor-mode" element={<SingleEditorModePage />} />
          <Route path="live-state-sync" element={<LiveStateSyncPage />} />
          <Route path="video-player" element={<VideoPlayerPage />} />
          <Route path="view-analytics" element={<ViewAnalyticsPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="nivo-charts" element={<NivoChartsPage />} />
          <Route path="reactions-inline" element={<ReactionsInlinePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;